import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ClientHiringChart = ({ data, description }) => {
  // Data preparation for chart
  const clientHiringData = () => {
    const clientData = {};
    
    data.forEach(candidate => {
      if (!candidate.client) return;
      
      if (!clientData[candidate.client]) {
        clientData[candidate.client] = {
          total: 0,
          hired: 0,
          rejected: 0
        };
      }
      
      clientData[candidate.client].total++;
      
      if (candidate.stage === 'Hired') {
        clientData[candidate.client].hired++;
      } else if (candidate.stage === 'Rejected') {
        clientData[candidate.client].rejected++;
      }
    });
    
    return Object.entries(clientData)
      .map(([client, data]) => ({
        name: client,
        ...data
      }))
      .sort((a, b) => b.total - a.total);
  };

  const chartData = clientHiringData();
  const totalHired = chartData.reduce((sum, client) => sum + client.hired, 0);
  const totalCandidates = chartData.reduce((sum, client) => sum + client.total, 0);

  return (
    <div className="dashboard-card p-6 slide-in-up" style={{animationDelay: '1100ms'}}>
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-1">Client Hiring Activity</h3>
          <p className="text-sm text-gray-500">Hiring outcomes across different clients</p>
        </div>
        <div className="text-right">
          <div className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-1 rounded-full mb-1">
            Client Activity
          </div>
          <p className="text-xs text-gray-500">{totalHired}/{totalCandidates} hired</p>
        </div>
      </div>
      {description && (
        <p className="text-sm text-gray-600 mb-4">{description}</p>
      )}
      <div className="bg-gray-50 rounded-lg p-4">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart 
            data={chartData} 
            margin={{ top: 20, right: 20, left: 20, bottom: 60 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} opacity={0.6} />
            <XAxis 
              dataKey="name" 
              tickLine={false} 
              axisLine={false} 
              style={{ fontSize: '10px', fill: '#6b7280' }} 
              angle={-45}
              textAnchor="end"
              height={50}
              interval={0}
              tickFormatter={(value) => value.length > 12 ? value.substring(0, 12) + '...' : value}
            />
            <YAxis 
              tickLine={false} 
              axisLine={false} 
              style={{ fontSize: '11px', fill: '#6b7280' }} 
              label={{ value: 'Number of Candidates', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fontSize: '11px', fill: '#6b7280' } }}
            />
            <Tooltip 
              contentStyle={{ 
                borderRadius: '12px', 
                border: 'none', 
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                fontSize: '12px',
                backgroundColor: 'white',
                padding: '12px'
              }}
              labelStyle={{ fontWeight: '600', color: '#374151', marginBottom: '8px' }}
              formatter={(value, name) => [value, name === 'hired' ? 'Hired' : 'Rejected']}
            />
            <Legend 
              iconType="rect" 
              iconSize={12} 
              align="center" 
              verticalAlign="top" 
              wrapperStyle={{ paddingBottom: '20px', fontSize: '11px' }} 
            />
            <Bar dataKey="hired" fill="#22c55e" name="Hired" barSize={20} radius={[2, 2, 0, 0]} />
            <Bar dataKey="rejected" fill="#ef4444" name="Rejected" barSize={20} radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ClientHiringChart;
